<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['new_patient']==1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="AddPatient">
              <div class="row">
                <div class="col-lg-4">
                    <div class="form-group mb-2">
                    <label for="exampleDataList">Patient's Name</label> <small class="text-danger">*</small>
                      <input class="form-control" list="patients" required @change="FilterPatient" v-model="patient_name" placeholder="Enter Patient's Name..."/>
                      <datalist id="patients">
                        <option v-for="item in patients" :key="item.id">{{ item.patient_id }}-{{ item.name }}-{{ item.telephone }}</option>
                      </datalist>
                    </div>
                    <div class="form-group mb-2">
                      <label for="input-date1">Visit Date</label> <small class="text-danger">*</small>
                      <input v-model="visitdate" type="date" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Telephone</label> <small class="text-danger">*</small>
                      <b-input-group prepend="+256"><input v-model="telephone" placeholder="Enter Telephone" v-mask="'#########'" type="text" class="form-control"/></b-input-group>
                    </div>
                    <div class="form-group mb-2">
                      <label>Gender</label> <small class="text-danger">*</small>
                      <select class="form-control" v-model="gender">
                        <option>Female</option>
                        <option>Male</option>
                      </select>
                    </div>
                    <div class="form-group mb-2">
                      <label for="input-date1">Date of Birth</label> <small class="text-danger">*</small>
                      <input v-model="dateofbirth" type="date" class="form-control" />
                    </div>  
                    <div class="form-group mb-2">
                      <label>Address</label> <small class="text-danger">*</small>
                      <!-- <input v-model="address" placeholder="Enter Address" type="text" class="form-control" /> -->
                      <input class="form-control" list="patientaddress" v-model="address" placeholder="Enter Address..."/>
                      <datalist id="patientaddress">
                        <option v-for="(addr, idx) in uniqueAddresses" :key="idx"> {{ addr }}</option>
                      </datalist>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <label>Nationality</label> <small class="text-danger">*</small>
                      <multiselect v-model="nationality" :options="countries" label="name"></multiselect>
                    </div>
                    <div class="form-group mb-2">
                      <label>Email Address</label> <small class="text-muted">(optional)</small>
                      <input v-model="email" type="email" placeholder="Enter Email Address" class="form-control"/>
                    </div>
                    <div class="form-group mb-2">
                      <label>NIN</label> <small class="text-muted">(optional)</small>
                      <input v-model="nin" placeholder="National ID Number" type="text" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Next of Kin Name</label> <small class="text-muted">(optional)</small>
                      <input v-model="nokname" placeholder="NOK Name" type="text" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Next of Kin Contact</label> <small class="text-muted">(optional)</small>
                      <input v-model="nokcontact" placeholder="NOK Contact" type="text" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Relation with Patient</label> <small class="text-muted">(optional)</small>
                      <input v-model="nokrelationship" placeholder="Relationship with Patient" type="text" class="form-control" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <label>Payment Type</label> <small class="text-danger">*</small>
                      <b-form-select class="form-control" @change="CheckPayType" v-model="payment_type">
                        <option value="1">Cash</option>
                        <option value="2">Group Account</option>
                        <option value="3">Personal Account</option>
                        <option value="4">Insurance</option>
                        <option value="5">Debt</option>
                      </b-form-select>
                    </div>
                    <div class="form-group mb-2" v-show="showaccountbalance">
                      <label>Account Balance</label>
                      <input v-model="account_balance" readonly type="number" class="form-control" />
                    </div>
                    <div class="form-group mb-2" v-show="showaccounts">
                      <label>Account Name</label>
                      <input v-model="account_name" readonly type="text" class="form-control" />
                      <input v-model="account_number" hidden type="text" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Service Category</label> <small class="text-danger">*</small>
                      <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
                    </div>
                    <div class="form-group mb-2">
                      <label>Service Name</label> <small class="text-danger">*</small>
                      <multiselect v-model="service_name" label="name" @input="FilterPrice" :options="services"></multiselect>
                    </div>
                    <div class="row" v-if="userData.permissions['edit_service_cost']==1">
                    <div class="form-group mb-2" >
                      <label>Service Cost</label> <small class="text-danger">*</small>
                      <input v-model="service_price"  required type="number" class="form-control" />
                    </div>
                    </div>
                    <div v-else>
                     <div class="row justify-content-center">
                       <div class="form-group mb-2" >
                      <label>Service Cost</label> <small class="text-danger">*</small>
                      <input v-model="service_price" readonly required type="number" class="form-control" />
                       </div>
                      </div>
                  </div> 
                    <div class="form-group mt-2"><br>
                    <b-button type="submit" class="btn w-100" :disabled="balancebtn <= false" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
                    <br><br><center><span class="text-danger">{{ error }}</span></center>
                    </div>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Add New Patients</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { patientMethods, patientComputed , countriesMethods, countriesComputed, serviceCategoryMethods,serviceCategoryComputed} from "@/state/helpers";

export default {
  page: {
    title: "Add Patient",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Add Patient",
      items: [{text: "Dashboard",href: "/"},{text: "Patients",active: true}],
      services:[],
      patient_name: "",
      telephone: "",
      visitdate: new Date().toLocaleDateString('fr-CA'),
      dateofbirth:new Date().toLocaleDateString('fr-CA'),
      nationality: "Uganda",
      age: "",
      gender: "Female",
      email: "",
      address: "",
      nin: "",
      nokname: "",
      nokcontact: "",
      nokrelationship: "",
      payment_type: "1",
      specification: "",
      service_category: "",
      service_name: "",
      service_price: "",
      account_balance:'',
      showaccountbalance:false,
      balancebtn:true,
      error:'',
      showaccounts:false,
      account_name:'',
      account_number:'',
      notifications:'',
    };
  },
  methods: {
    ...patientMethods,
    ...countriesMethods,
    ...serviceCategoryMethods,
    async CheckPayType(){
      if (this.payment_type=='3') {
        let url = `/checkpaytype/${this.patient_name}`;
        await axios.get(url).then((response) => {
          this.account_balance = response.data.balance;
          this.showaccountbalance=true;
          this.balancebtn=true;
          this.error = ""; 
        });
      } else if (this.payment_type=='2') {
        let url = `/findgroupaccountmember/${this.patient_name}`;
        await axios.get(url).then((response) => {
          if (response.data.accounts.length>0) {
            this.account_name = response.data.accounts[0].account.acc_name;
            this.account_number = response.data.accounts[0].account.acc_number;
            this.showaccounts=true;
            this.error = ""; 
            this.showaccountbalance=false;
            this.balancebtn=true;
          } else {
            this.account_name ='';
            this.account_number = '';
            this.showaccountbalance=false;
            this.showaccounts=false;
            this.error = "Patient doesn`t belong to any active Group Account."; 
            this.balancebtn=false;
          }
        });
      } else if (this.payment_type=='4' && this.userData.permissions['add_debt_patients']!=1) {
          this.error = "No Permission to add Insurance Patients"; 
          this.balancebtn=false;
      } else if (this.payment_type=='5' && this.userData.permissions['add_debt_patients']!=1) {
          this.error = "No Permission to add Debt Patients"; 
          this.balancebtn=false;
      } else {
          this.balancebtn=true;
          this.showaccounts=false;
          this.showaccountbalance=false;
          this.error='';
      }
    },
    async FilterCategory(){
      let url = `/servicebycategory/${this.service_category.id}`;
        await axios.get(url).then((response) => {
          this.services = response.data.services;
        });
    },
    async FilterPrice(){
        let url = `/serviceprice/${this.service_name.id}`;
        await axios.get(url).then((response) => {
          this.service_price = response.data.price;
          if (this.payment_type=='3') {
            this.balance=this.account_balance-this.service_price;
            if (this.balance<0) {
              this.balancebtn=false;
              this.error="Insufficient Balance";
            } else {
              this.error='';
              this.balancebtn=true;
            }            
          } else {
              this.error='';
              this.balancebtn=true;
            }  
          });
      },
    async FilterPatient(){
      let url = `/findpatient/${this.patient_name}`;
        await axios.get(url).then((response) => {
        if (response.data.patients) {
          this.telephone = response.data.patients[0].telephone;
          this.dateofbirth = response.data.patients[0].date_of_birth;
          this.address = response.data.patients[0].address;
          this.nin = response.data.patients[0].nin;
          this.email = response.data.patients[0].email;
          this.gender = response.data.patients[0].gender;
        }});

        let url1 = `/findpatientbalance/${this.patient_name}`;
        await axios.get(url1).then((response) => {
          if (response.data.balance>0) {
            this.error = "Patient has a pending balance "+ response.data.balance +" ugx"; 
          }
        });
    },
    async AddPatient() { 
        this.error = "Saving Patient Visit"; 
        this.balancebtn=false;
        let formData = new FormData();
        formData.append("patient", this.patient_name);
        formData.append("visitdate", this.visitdate);
        formData.append("telephone", this.telephone);
        formData.append("gender", this.gender);
        formData.append("date_of_birth", this.dateofbirth);
        formData.append("nationality", this.nationality.name);
        formData.append("address", this.address);
        formData.append("email", this.email);
        formData.append("nin", this.nin);
        formData.append("nokname", this.nokname);
        formData.append("nokcontact", this.nokcontact);
        formData.append("nokrelationship", this.nokrelationship);
        formData.append("payment_type", this.payment_type);
        formData.append("account_number", this.account_number);
        formData.append("service_category", this.service_category.id);
        formData.append("service_name", this.service_name.id);
        formData.append("service_price", this.service_price);
        let url = "/addpatient";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPatients();
            this.$bvModal.hide('new-unit');
            this.patient_name="";
            this.telephone="";
            this.address="";
            this.email="";
            this.nin="";
            this.nokname="";
            this.nokcontact="";
            this.nokrelationship="";
            this.service_category="";
            this.service_name="";
            this.service_price="";
            this.showaccountbalance=false;
            this.showaccounts=false;
            this.$toast.success("New Patient Visit Added");
            this.error = ""; 
            this.balancebtn=true;
        }
        });
      },
  },
  computed: {
    ...patientComputed,
    ...countriesComputed,
    ...serviceCategoryComputed,
    uniqueAddresses() {
      return [...new Set(this.patients.map(item => item.address).filter(addr => addr))]
    }
  },
  created() {
    this.fetchPatients();
    this.fetchServiceCategory();
    this.fetchCountries();
    this.nationality = this.countries.find(option => option.name = 'Uganda');
  },
  mounted(){
    this.nationality = this.countries.find(option => option.name = 'Uganda');
  },
};
</script>